import Head from 'next/head';
import React from 'react';
import { Query } from 'react-apollo';
import styled from 'styled-components';
import getOffers from '../../src/apollo/graphql/offer/getOffers';
import Breadcrumb from '../../src/components/Breadcrumb';
import { ButtonMore } from '../../src/components/Button';
import { DropFilter } from '../../src/components/Filter';
import { Column, Container, Row } from '../../src/components/Grid';
import Header from '../../src/components/Header';
import { Main, Offer, Page, Section } from '../../src/components/Layout';
import { withI18N } from '../../src/hoc/index';
import { media } from '../../src/styles/media';
import createContext from '../../src/utils/format/createContext';
import getPageByType from '../../src/apollo/graphql/page/getPageByType';
import CardWithImageInArc from '../../src/components/Card/CardWithImageInArc';

const ButtonContainer = styled.div`
  text-align: center;
`;

const StyledColumn = styled(Column)`
  margin-bottom: ${props => props.theme.layout.gutter * 3}px;
  display: flex;
  justify-content: center;
`;

const DropFilterWrapper = styled.div`
  display: flex;

  position: absolute;
  z-index: 3;
  top: -45px;
  width: 100%;
  align-items: center;
  justify-content: center;
  right: 0;

  ${media.tablet`
    top: 0;
    width: auto;
    right: ${props => props.theme.layout.gutter * 0.75}px;
  `};
`;

const filters = translator => {
  return [
    {
      label: translator('common:offers.filter.criteria.date'),
      value: 1
    },
    {
      label: translator('common:offers.filter.criteria.brand'),
      value: 2
    }
    // {
    //   label: translator('common:offers.filter.criteria.welfare'),
    //   value: 3
    // },
    // {
    //   label: translator('common:offers.filter.criteria.boutiques'),
    //   value: 4
    // },
    // {
    //   label: translator('common:offers.filter.criteria.restaurant'),
    //   value: 5
    // }
  ];
};

const sortById = array =>
  [...array].sort((a, b) => {
    if (a.id < b.id) return 1;
    if (a.id > b.id) return -1;
    return 0;
  });

const sortByName = array => {
  let newArray = array.map(e => {
    return Object.assign(e, {
      name: e.shop ? e.shop.name : e.pageBuilder.detail.title
    });
  });
  return newArray.sort((a, b) => {
    if (a.name < b.name) return -1;
    if (a.name > b.name) return 1;
    return 0;
  });
};

const sortByCustom = array => {
  let arrayToReturn = array;
  let arrayWithOrder = [];
  let arrayWithOutOrder = [];
  let asOrderValue = false;

  arrayToReturn.forEach(el => {
    if (el.detail.order !== null && el.detail.order !== -1) {
      arrayWithOrder.push(el);
    } else {
      arrayWithOutOrder.push(el);
    }
  });

  arrayWithOrder.sort(function(a, b) {
    return a.detail.order - b.detail.order;
  });

  arrayToReturn = arrayWithOrder.concat(arrayWithOutOrder);
  return arrayToReturn;
};

class Offers extends React.PureComponent {
  pagination = {
    current: 1,
    offset: 6,
    max: 0
  };

  constructor(props) {
    super(props);

    this.state = {
      items: [],
      filter: filters(props.t)[0],
      displayButton: false
    };
  }

  componentDidMount() {
    /*this.setState({
      items: this.props.items.slice(0, this.pagination.offset),
      displayButton: this.props.items.length > 6
    });*/
    //this.pagination.max = this.props.items.length;
    // this.setState({
    //   items: data.slice(0, this.pagination.offset),
    //   displayButton: data.length > 6
    // });
    // this.pagination.max = data.length;
  }

  _handleLoadMore = () => {
    // this.pagination.current++;
    // const max = this.pagination.current * this.pagination.offset;
    // const min = max - this.pagination.offset;
    /*this.setState(prevState => ({
      items: [...prevState.items, ...this.props.items.slice(min, max)]
    }));*/
    // this.setState(prevState => ({
    //   items: [...prevState.items, ...data.slice(min, max)]
    // }));
    // if (max >= this.pagination.max) {
    //   this.setState({ displayButton: false });
    // }
  };

  _handleChange = filter => {
    this.setState({ filter });
  };

  renderButton = () => {
    const { displayButton } = this.state;
    return (
      displayButton && (
        <ButtonContainer>
          <ButtonMore onClick={this._handleLoadMore}>Afficher plus</ButtonMore>
        </ButtonContainer>
      )
    );
  };

  renderFilter = () => {
    const translatedFilters = filters(this.props.t);
    const { filter } = this.state;
    return (
      <DropFilterWrapper>
        <DropFilter
          label={this.props.t('common:offers.filter.title')}
          items={translatedFilters}
          handleChange={this._handleChange}
          value={filter}
        />
      </DropFilterWrapper>
    );
  };

  renderOffers = offers => {
    const { t } = this.props;
    return (
      <Section>
        <Container>
          <Row>
            {offers.map(offer => {
              const { detail } = offer;
              const buttonUrl = detail.cta_url
                ? detail.cta_url
                : offer.shop_id
                  ? `${t('common:brands.navigation.brands')}/${offer?.shop
                      ?.type || 'unknown'}/${offer?.shop?.category?.detail
                      ?.slug || 'uncategorized'}/${offer.shop.slug}`
                  : `page/${offer.pageBuilder.detail.slug}`;

              const labelUrl = detail.cta_label || t('common:button.discover');

              let logoUrl;
              if (offer?.shop) {
                logoUrl = offer?.shop?.logo2Desk;
              } else if (offer?.pageBuilder) {
                const timeBlock = offer?.pageBuilder?.blocks?.find(
                  b => b.type === 'time_block'
                );
                logoUrl = timeBlock?.img_desktop || timeBlock?.img_mobile;
              }

              const offerDetail = {
                title: detail?.title,
                description: detail?.description,
                date: detail?.offer_date,
                image: {
                  url: offer.image,
                  alt: detail?.title,
                  height: 305,
                  width: 305
                },
                logo: {
                  url: logoUrl || null,
                  alt: detail?.title
                },
                ctaLeft: {
                  label: labelUrl,
                  url: buttonUrl
                }
              };

              return (
                <StyledColumn key={offer.id} tablet={2} desktop={3}>
                  <CardWithImageInArc
                    card={offerDetail}
                    maxWidth={305}
                    minWidth={305}
                    fullHeight
                  />
                </StyledColumn>
              );
            })}
          </Row>
          {this.renderButton()}
        </Container>
      </Section>
    );
  };

  renderPage = (offers, page) => (
    <div>
      <Head>
        <title key="title">Grand Hôtel-Dieu</title>
      </Head>
      <Header
        title={page.detail && page.detail.title}
        image={page.img_header_desktop}
        imageMobile={page.img_header_mobile}
      />
      <Main>
        <Container>
          <Breadcrumb
            items={[
              { href: '/', label: this.props.t('common:nav.tabs.home') },
              { label: this.props.t('common:nav.menu.offers') }
            ]}
          />
          {this.renderFilter()}
        </Container>
        {this.renderOffers(offers)}
      </Main>
    </div>
  );

  render() {
    const { i18n } = this.props;

    return (
      <Page offers>
        <Query
          query={getPageByType}
          variables={{ type: 'offers' }}
          context={createContext(i18n.language)}
        >
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPageByType) {
              const page = data.getPageByType;
              return (
                <Query query={getOffers} context={createContext(i18n.language)}>
                  {singleOffers => {
                    if (
                      !singleOffers.loading &&
                      !singleOffers.error &&
                      singleOffers.data &&
                      singleOffers.data.getOffers
                    ) {
                      let offers = [];
                      const { filter } = this.state;
                      if (filter.value === 1) {
                        offers = sortById(singleOffers.data.getOffers);
                      } else if (filter.value === 2) {
                        offers = sortByName(singleOffers.data.getOffers);
                      } else {
                        offers = sortByCustom(offers);
                      }

                      return this.renderPage(offers, page);
                    }

                    return <div />;
                  }}
                </Query>
              );
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(Offers);
